import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import './TS_ButtonLoader.scss';
export class TS_ButtonLoader extends React.Component {
    render() {
        return _jsxs("div", { className: "ts-button-loader", children: [_jsx("div", {}), _jsx("div", {}), _jsx("div", {}), _jsx("div", {})] });
    }
}
//# sourceMappingURL=TS_ButtonLoader.js.map